import script from "./RoundView.vue?vue&type=script&setup=true&lang=js"
export * from "./RoundView.vue?vue&type=script&setup=true&lang=js"

import "./RoundView.vue?vue&type=style&index=0&id=1ff463d8&lang=css"

const __exports__ = script;

export default __exports__